import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-line bg-white px-4 py-12" data-id="element-159" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-160" data-mp="32nulgo2wc31d">
        <p className="text-lg font-black uppercase tracking-tight text-primary" data-id="element-161" data-mp="32p5qer82vgu2">
          💪 Combo Completo Hipertrofia 2026
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-162" data-mp="36n3gdw9oa6yi">
          El sistema de hipertrofia, especialización y adaptaciones para entrenadores de gimnasio de
          todos los niveles en Argentina.
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-163" data-mp="3lec768pb9yd8">
          Porque entrenar no debería ser un misterio. Debería ser un SISTEMA.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:gap-6" data-id="element-164" data-mp="3qbvojhhb2r9e">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="mailto:compradigitalyaa@gmail.com" data-id="element-165" data-mp="2eya1q2yx51r1">
            <MailIcon className="h-4 w-4" data-id="element-166" data-mp="3gagyrmubl72o" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-167" data-mp="3gck0v58qyqnr">
            <GlobeIcon className="h-4 w-4" data-id="element-168" data-mp="81ywqhwtbw3g" /> www.compradigitalya.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://instagram.com/compradigitalya" target="_blank" rel="noopener noreferrer" data-id="element-169" data-mp="34gt971ke92u">
            <InstagramIcon className="h-4 w-4" data-id="element-170" data-mp="cw3595lq8c6n" /> @compradigitalya
          </a>
        </div>
        <div className="mt-7 border-t border-line pt-6" data-id="element-171" data-mp="qrfboa98vr3e">
          <p className="text-base font-black text-ink" data-id="element-172" data-mp="msy09eisjug6">
            💪 “El próximo ciclo puede ser diferente.”
          </p>
          <p className="mt-1 text-sm font-semibold italic text-primary" data-id="element-173" data-mp="twxv9kvlbuel">
            “Finalmente un programa que FUNCIONA.”
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-174" data-mp="13tkds30g29dg">
            © CompraDigitalYa™ 2026 — Todos los derechos reservados.
            <br data-id="element-175" data-mp="18ksnz19llyro" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}